import page from './Page'
import pageContent from './PageContent'
import spacer from './Spacer'
import message from './Message'
import loading from './Loading'

export const Page = page
export const PageContent = pageContent
export const Spacer = spacer
export const Message = message
export const Loading = loading
